import { createBrowserRouter, Navigate } from "react-router-dom";
import ChartOfAccounts from "../components/Accounting/ChartOfAccounts";
import Customers from "../components/Customers";
import Breadcrumb from "../components/Breadcrumb";
import NotFound from "../components/NotFound";
import Sales from "../components/Sales";
import Settings from "../components/Settings";
import Suppliers from "../components/Suppliers";
import Root from "./root";

export default createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <NotFound />,
    children: [
      {
        errorElement: <NotFound />,
        children: [
          {
            path: "accounting/coa",
            element: <ChartOfAccounts />,
            handle: {
              crumb: () => [
                <Breadcrumb key="/accounting" to="/accounting">
                  Accounting
                </Breadcrumb>,
                <Breadcrumb key="/accounting/coa" to="/accounting/coa">
                  Chart Of Accounts
                </Breadcrumb>,
              ],
              searchable: false,
            },
          },
          {
            path: "customers",
            element: <Customers />,
            handle: {
              crumb: () => (
                <Breadcrumb key="/customers" to="/customers">
                  Customers
                </Breadcrumb>
              ),
              searchable: false,
            },
          },
          {
            index: true,
            element: <Navigate to="/sales" replace={true} />,
          },
          {
            path: "sales",
            element: <Sales />,
            handle: {
              crumb: () => (
                <Breadcrumb key="/sales" to="/sales">
                  Sales
                </Breadcrumb>
              ),
              searchable: true,
            },
          },
          {
            path: "settings",
            element: <Settings />,
            handle: {
              crumb: () => (
                <Breadcrumb key="/settings" to="/settings">
                  Settings
                </Breadcrumb>
              ),
              searchable: false,
            },
          },
          {
            path: "suppliers",
            element: <Suppliers />,
            handle: {
              crumb: () => (
                <Breadcrumb key="/suppliers" to="/suppliers">
                  Suppliers
                </Breadcrumb>
              ),
              searchable: false,
            },
          },
        ],
      },
    ],
  },
]);
